// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2MJtg","overflowing":"ReadFullNote_overflowing__3iEBt"};